import { useDispatch } from 'react-redux';

import { useCurrentPage } from './useCurrentPage';
import { useEffect } from 'react';
import { Page } from '../util/sections';
import { changePage } from '../reducers/graph';
import { usePages } from './useQuestionnairePages';

export const useUpdatePage = (page?: Page) => {
  const dispatch = useDispatch();
  const currentPage = useCurrentPage();
  const pages = usePages();

  useEffect(() => {
    if (page && pages.includes(page) && page !== currentPage) {
      dispatch(changePage(page));
    }

    // I think this is not needed....?
    // else if (!page) {
    //   navigateToPage(currentPage);
    // }
  }, [currentPage, page, dispatch, pages]);
};
